module.exports = new __parcel__URL__("bp_stardust_icon.d542f075.png").toString();